<template>
  <el-dialog
    :title="editForm.id==null||editForm==''?'登记充电桩':'编辑充电桩'"
    :visible="editFormVisible"
    :modal-append-to-body='false'
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :before-close="clearEditForm">
    <el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-col :span="12">
        <el-form-item label="桩编号" :label-width="formLabelWidth" prop="pileCode">
          <el-input v-model="editForm.pileCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电桩名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="editForm.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电桩类型" :label-width="formLabelWidth" prop="pileType">
          <el-select placeholder="请选择" v-model="editForm.pileType">
            <el-option v-for="item in pileTypeData" :key="item.value"
                       v-bind:label="item.message+'桩'" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否检查连接" :label-width="formLabelWidth" prop="checkConnection">
          <el-select placeholder="请选择" v-model="editForm.checkConnection">
            <el-option v-for="item in checkConnectionData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否支持并充" :label-width="formLabelWidth" prop="together">
          <el-select placeholder="请选择" v-model="editForm.together">
            <el-option v-for="item in togetherData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营商" :label-width="formLabelWidth" prop="operatorId">
<!--          <el-select placeholder="运营商" v-model="editForm.operatorId"  @change="operatorSelect">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini"  ref="cascader"
                        placeholder="运营商"  filterable
                        :options="this.setTreeDisable(this.operatorTree)"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        :show-all-levels="false"
                        change-on-select
                        @change='handleChangeStation'
                        v-model="editForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属站" :label-width="formLabelWidth" prop="stationId">
          <el-select placeholder="所属站" v-model="editForm.stationId" @change="stationSelect">
            <el-option v-for="item in stationsForSelect" :key="item.id"
                       v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="型号" :label-width="formLabelWidth" prop="pileTypeId">
          <el-select placeholder="请选择" v-model="editForm.pileTypeId" @change="pileTypeSelect">
            <el-option v-for="item in pileTypeForSelect" :key="item.id"
                       v-bind:label="'('+item.typeModel+')  '+item.typeName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="枪口数量" :label-width="formLabelWidth" prop="gunCount">
          <el-input disabled v-model="editForm.gunCount" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="快慢充" :label-width="formLabelWidth" prop="fastOrSlow">
          <el-select placeholder="请选择" v-model="editForm.fastOrSlow">
            <el-option v-for="item in fastOrSlowData" :key="item.value"
                       v-bind:label="item.message+'桩'" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="额定功率" :label-width="formLabelWidth" prop="ratedPower">
          <el-input disabled v-model="editForm.ratedPower" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="输出电流范围" :label-width="formLabelWidth" prop="outputCurrentRange">
          <el-input disabled v-model="editForm.outputCurrentRange" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电接口标准" :label-width="formLabelWidth" prop="chargingInterface">
          <el-select placeholder="请选择" v-model="editForm.chargingInterface">
            <el-option v-for="item in interfaceStandardData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="软件协议" :label-width="formLabelWidth" prop="protocol">
          <el-select placeholder="请选择" v-model="editForm.protocol">
            <el-option v-for="item in protocolData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="生产厂商" :label-width="formLabelWidth" prop="manufacturer">
          <el-input v-model="editForm.manufacturer" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="装户号" :label-width="formLabelWidth" prop="consNo">
          <el-input v-model="editForm.consNo" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="辅源类型" :label-width="formLabelWidth" prop="auxiliarySourceType">
          <el-select placeholder="请选择" v-model="editForm.auxiliarySourceType">
            <el-option v-for="item in auxiliarySourceTypeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否启用" :label-width="formLabelWidth" prop="enabledStateFlag">
          <el-select v-model="editForm.enabledStateFlag" placeholder="请选择">
            <el-option label="启用" value="Y"></el-option>
            <el-option label="不启用" value="N"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="安装日期" :label-width="formLabelWidth" prop="installDate">
          <el-date-picker v-model="editForm.installDate" type="date" value-format="yyyy-MM-dd"	 placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="生产日期" :label-width="formLabelWidth" prop="produceDate">
          <el-date-picker v-model="editForm.produceDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="免费运营时间" :label-width="formLabelWidth" prop="freeOperatingTime">
          <el-date-picker v-model="editForm.freeOperatingTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
      </el-col>
      <!--隐藏id-->
      <el-col :span="12">
        <el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
          <el-input v-model="editForm.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">取 消</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {validateInput} from '../../../../common/validator'
  export default {
    name: "add",
    data(){
      return{
        editFormRules: {
          pileCode: [{required: true, message: '请输桩编号', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,17,true,true,true,false,false,false,false)
            }, trigger: 'blur'}],
          name: [{required: true, message: '请输入站名称', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,16,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
          pileType: [{required: true, message: '请选择充电桩类型', trigger: 'blur'}],
          protocol: [{required: true, message: '请选择协议厂家', trigger: 'blur'}],
          checkConnection: [{required: true, message: '请选择是否检查连接', trigger: 'blur'}],
          pileTypeId: [{required: true, message: '请选择型号', trigger: 'blur'}],
          fastOrSlow: [{required: true, message: '请选择快慢充', trigger: 'blur'}],
          chargingInterface: [{required: true, message: '请输入充电接口标准', trigger: 'blur'}],
          auxiliarySourceType: [{required: true, message: '请输入辅源类型', trigger: 'blur'}],
          operatorId: [{required: true, message: '请选择运营商', trigger: 'blur'}],
          stationId: [{required: true, message: '请选择所属站', trigger: 'blur'}],
          enabledStateFlag: [{required: true, message: '请选择是否启用', trigger: 'blur'}],
          installDate: [{required: true, message: '请选择安装日期', trigger: 'blur'}],
          produceDate: [{required: true, message: '请选择生产日期', trigger: 'blur'}],
          /*freeOperatingTime: [{required: true, message: '请选择免费运营时间', trigger: 'blur'}],*/
          manufacturer:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,16,true,true,false,false,false,false,false)
            }, trigger: 'blur'}]
        },
        formLabelWidth: '150px',
        YesNoEnumData:[
          {value: 'Q', message: '是'},
          {value: 'N', message: '否'}
        ],
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      checkConnectionData:"",
      togetherData:"",
      operatorForSelect:"",
      operatorTree:{
        type: Array,
        required: true
      },
      stationsForSelect:{},
      pileTypeForSelect:{},
      fastOrSlowData:"",
      pileTypeData:"",
      interfaceStandardData:"",
      protocolData:"",
      auxiliarySourceTypeData:"",
      editSubmitLoading:false
    },
    methods:{
      operatorDisable(item) {
        // 判断是否为潜在运营商
        const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true : false
        return flag
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeStation(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
      operatorSelect(val){
        this.$emit("operatorSelect", val)
      },
      stationSelect(val){
        this.$emit("stationSelect", val)
      },
      pileTypeSelect(val){
        this.$emit("pileTypeSelect", val,this.editForm)
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    height: auto;
    .el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
      line-height: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/deviceManager/add.vue